"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endGameData = endGameData;
const Game_1 = require("./Game");
const IGO50CutScene_1 = require("./IGO50CutScene");
const KHContainer_1 = require("./KH/KHContainer");
const Z20SceneNames_1 = require("./Z20SceneNames");
class Z20CutScene extends IGO50CutScene_1.IGO50CutScene {
    constructor() {
        super(Z20SceneNames_1.default.Cutscene);
    }
    init(data) {
        data = data.scenes ? data : startGameData();
        super.init(data);
    }
}
exports.default = Z20CutScene;
function createDefaultImageContainer(scene) {
    const container = new KHContainer_1.KHContainer(scene, (Game_1.game.width - 192) / 2, ((16 * 10) - 128) / 2, 192, 128, 0x0, 1, 0, true);
    const sprite = scene.add.sprite(0, 0, 'intro_1').setOrigin(0, 0);
    container.add(sprite);
    return {
        container,
        bg: sprite
    };
}
const spritesToAdd = [
    { sprite: 'npc1', x: 10, y: 7 },
    { sprite: 'npc5', x: 9, y: 3 },
    { sprite: 'npc9', x: 2, y: 6 },
    { sprite: 'npc2', x: 2, y: 1 },
    { sprite: 'npc6', x: 8, y: 1 },
    { sprite: 'npc4', x: 5, y: 3 },
    { sprite: 'trophy', x: 5, y: 2 },
];
function startGameData() {
    return {
        allowSkipping: true,
        autoplay: true,
        autoplayTime: 2000,
        onFinish: (scene) => {
            scene.scene.start(Z20SceneNames_1.default.Menu);
        },
        scenes: [
            {
                getArt(scene) {
                    const stuff = createDefaultImageContainer(scene);
                    stuff.bg.visible = false;
                    scene.tweens.addCounter({
                        from: 4,
                        to: 0,
                        duration: 1000,
                        onUpdate: (tween) => {
                            const value = Math.floor(tween.getValue());
                            if (value < 3) {
                                stuff.bg.visible = true;
                                stuff.bg.setFrame(value);
                            }
                            else {
                                stuff.bg.visible = false;
                            }
                        },
                    });
                    return { go: stuff.container, bg: stuff.bg };
                },
                lines: [
                    'Deep in the Forest Wernat...',
                ]
            }, {
                getArt(scene) {
                    const stuff = createDefaultImageContainer(scene);
                    let i = 0;
                    const sprites = [];
                    function addSprite(sprite) {
                        const sprite2 = scene.add.sprite(sprite.x * 16, sprite.y * 16, sprite.sprite).setOrigin(0);
                        stuff.container.add(sprite2);
                        sprite2.visible = false;
                        return sprite2;
                    }
                    for (let sprite of spritesToAdd) {
                        sprites.push(addSprite(sprite));
                    }
                    const timer = scene.time.addEvent({
                        delay: 200,
                        callback: () => {
                            sprites[i].visible = true;
                            if (i === sprites.length - 2) {
                                sprites[i + 1].visible = true;
                            }
                            i++;
                        },
                        repeat: spritesToAdd.length - 2
                    });
                    return { go: stuff.container, bg: stuff.bg, timer, sprites };
                },
                onFinish(scene, art) {
                    const sprites = art.sprites;
                    for (const sprite of sprites) {
                        sprite.visible = true;
                    }
                    const timer = (art.timer);
                    timer.destroy();
                    for (let i = 0; i < sprites.length; i++) {
                        scene.tweens.add({
                            targets: sprites[i],
                            y: sprites[i].y - 300,
                            duration: 600,
                        });
                    }
                    return 600;
                },
                lines: [
                    'The beasts, the fae, and the monsters play.',
                    "You've been waiting ages for your turn to play...",
                    'But beware, the forest folk are fickle.',
                    "But if you don't reach the goal in 20 seconds, it's over!",
                ]
            }, {
                getArt(scene) {
                    const stuff = createDefaultImageContainer(scene);
                    return { go: stuff.container, bg: stuff.bg };
                },
                onFinish(scene, art) {
                    scene.tweens.addCounter({
                        from: 0,
                        to: 4,
                        duration: 1000,
                        onUpdate: (tween) => {
                            const sprite = art.bg;
                            const value = Math.floor(tween.getValue());
                            if (value < 3) {
                                sprite.visible = true;
                                sprite.setFrame(value);
                            }
                            else {
                                sprite.visible = false;
                            }
                        },
                    });
                    return 1500;
                },
                lines: [
                    "Will you overcome Wernat's hardest trial?"
                ]
            }
        ]
    };
}
function endGameData(sprite, time) {
    return {
        allowSkipping: true,
        autoplay: false,
        onFinish: (scene) => {
            scene.scene.start(Z20SceneNames_1.default.Menu);
        },
        scenes: [
            {
                getArt(scene) {
                    const w = 192;
                    const h = 128;
                    const container = new KHContainer_1.KHContainer(scene, (Game_1.game.width - w) / 2, ((16 * 10) - h) / 2, w, h);
                    container.add(scene.add.image(0, 0, 'cutscene_end').setOrigin(0, 0));
                    container.add(scene.add.sprite(96, 72, sprite || 'npc1').setOrigin(0.5, 0.5));
                    return { go: container };
                },
                lines: ["Congratulations! No one else got to play. You hogged playing as the trickster all day!", `Time taken: ${time.toFixed(2)}s`]
            }
        ],
        terminalCode: 'LONG-PAST',
    };
}
